import { render, staticRenderFns } from "./ChatfuelMsgs.vue?vue&type=template&id=219a6f77&"
import script from "./ChatfuelMsgs.vue?vue&type=script&lang=js&"
export * from "./ChatfuelMsgs.vue?vue&type=script&lang=js&"
import style0 from "./ChatfuelMsgs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports